import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import styles from './index.module.scss';

import ErrorPage from 'views/Errors/ErrorPage';
import { AuthContext } from 'context/AuthContext';
import useStore from 'utils/hooks/useStore';
import getRetailerOverride from 'utils/methods/getRetailerOverride';
import { ERROR_SOURCES } from 'dictionary/errorSources';

export default function RetailerGuard({ children = null }) {
  const { hasError, errorObject } = useContext(AuthContext);
  const { storeProperties } = useStore();
  const { search } = useLocation();

  const source = _get(errorObject, 'source', '');
  const statusCode = _get(errorObject, 'statusCode', '');
  const retailer = getRetailerOverride(search);

  useEffect(() => {
    window.retailer = retailer;
  }, [retailer]);

  const isInvalidStore = !storeProperties || _isEmpty(storeProperties);
  const isInactiveStore =
    hasError && source === ERROR_SOURCES.STORE_PROPERTIES && statusCode === 404;

  if (isInvalidStore) {
    return <ErrorPage allowRefresh hideHomeButton />;
  }

  if (isInactiveStore) {
    return (
      <div className={styles.notFound}>
        <h1>You might’ve taken a wrong turn</h1>
        <p>Oops! We could not find the page you were looking for.</p>
        <p>
          You tried to visit: <span>{window.location.host}</span>
        </p>
      </div>
    );
  }

  return <div className={styles.container}>{children}</div>;
}
